import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, concatMap, map, switchMap } from 'rxjs/operators';
import { CustomOrderHistoryAdapter } from '../custom-order-history.adapter';
import { CustomOrderHistory, CustomOrderHistoryOverview } from '../custom-order-history.models';
import * as CustomOrderHistoryActions from './custom-order-history.actions';

@Injectable()
export class CustomOrderHistoryEffects {

  getOrderHistory$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CustomOrderHistoryActions.getOrderHistoryOverview),
      switchMap((action) =>
        this.customOrderHistoryAdapter
          .getOrders(
            action.formData
          )
          .pipe(
            map((overview: CustomOrderHistoryOverview) =>
              CustomOrderHistoryActions.getOrderHistoryOverviewSuccess({
                overview,
              })
            ),
            catchError((error) =>
              of(
                CustomOrderHistoryActions.getOrderHistoryOverviewFailure({
                  error,
                })
              )
            )
          )
      )
    );
  });

  getOrder$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CustomOrderHistoryActions.getOrderHistory),
      switchMap((action) =>
        this.customOrderHistoryAdapter
          .getOrder(
            action.uigOrderNumber,
          )
          .pipe(
            map((order: CustomOrderHistory) => {
              if(order) {
                return CustomOrderHistoryActions.getOrderHistorySuccess({
                  order
                });
              }
              else {
                return CustomOrderHistoryActions.getOrderHistoryFailure({ 'error': new Error()});
              }
            }),
            catchError((error) =>
              of(
                CustomOrderHistoryActions.getOrderHistoryFailure({
                  error,
                })
              )
            )
          )
      )
    );
  });

  cancelOrder$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CustomOrderHistoryActions.cancelOrder),
      switchMap((action) =>
        this.customOrderHistoryAdapter
          .cancelOrder(
            action.uigOrderNumber
          )
          .pipe(
            map((success) => {
              if(success) {
                return CustomOrderHistoryActions.cancelOrderSuccess();
              }
              else {
                return CustomOrderHistoryActions.cancelOrderFailure();
              }
            }),
            catchError((error) =>
              of(
                CustomOrderHistoryActions.cancelOrderFailure()
              )
            )
          )
      )
    );
  });

  cancelOrderEntry$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CustomOrderHistoryActions.cancelOrderEntry),
      switchMap((action) =>
        this.customOrderHistoryAdapter
          .cancelOrderEntry(
            action.uigOrderNumber,
            action.position
          )
          .pipe(
            map((success) => {
              if(success) {
                return CustomOrderHistoryActions.cancelOrderEntrySuccess();
              }
              else {
                return CustomOrderHistoryActions.cancelOrderEntryFailure();
              }
            }),
            catchError((error) =>
              of(
                CustomOrderHistoryActions.cancelOrderEntryFailure()
              )
            )
          )
      )
    );
  });

  updateOrderEntries$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CustomOrderHistoryActions.updateOrderEntries),
      switchMap((action) =>
        this.customOrderHistoryAdapter
          .updateOrderEntries(
            action.formData
          )
          .pipe(
            map((success) => {
              if(success) {
                return CustomOrderHistoryActions.updateOrderEntriesSuccess();
              }
              else {
                return CustomOrderHistoryActions.updateOrderEntriesFailure();
              }
            }),
            catchError((error) =>
              of(
                CustomOrderHistoryActions.updateOrderEntriesFailure()
              )
            )
          )
      )
    );
  });

  constructor(
    private actions$: Actions,
    private customOrderHistoryAdapter: CustomOrderHistoryAdapter
  ) {}
}
